// ast-grep-ignore: no-absolute-fortune-urls

import Cookies from 'js-cookie';

const getUserTokenCookieDomain = () => {
  const baseUrl = process.env.SITE_BASE_URL || '';
  const deployedBaseUrLs = [
    'https://develop.fortune.com',
    'https://staging.fortune.com',
    'https://qa.fortune.com',
    'https://fortune.com',
  ];
  if (deployedBaseUrLs.includes(baseUrl)) {
    return { domain: `.${window.location.hostname}` };
  }
  return {};
};

/**
 * Sets the __fortuneRelease cookie to route traffic to different backends
 */
export const setFortuneReleaseCookie = (value: string) => {
  const cookieOptions = {
    ...getUserTokenCookieDomain(),
    expires: 1, // 1 day
    path: '/',
    sameSite: 'strict' as const,
  };

  Cookies.set('__fortuneRelease', value, cookieOptions);
};

/**
 * Deletes the __fortuneRelease cookie
 */
export const deleteFortuneReleaseCookie = () => {
  const cookieOptions = {
    path: '/',
    ...getUserTokenCookieDomain(),
  };

  Cookies.remove('__fortuneRelease', cookieOptions);
};

/**
 * Gets the current value of the __fortuneRelease cookie
 */
export const getFortuneReleaseCookie = (): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  return Cookies.get('__fortuneRelease') || null;
};
